<template>
  <div class="BUT_Setting">
    <table>
      <tr align="left">
        <td class="BUT_name" style="font-size: 26px; table-layout: fixed">FBUT：</td>
        <td>
          <el-switch
            v-model="isDrawBUT"
            :active-text="showText"
            :inactive-text="notShowText"
            @change="changeSwitch"
          >
          </el-switch>
        </td>
        <!-- 取消FBUT自动拍摄 -->
        <!-- <td style="padding-left:40px">
          <el-switch  v-model="BUTModel" :active-text="auto" :inactive-text="manual" @change="changeModel"> </el-switch>
        </td> -->
      </tr>
    </table>
    <div>
      <el-form class="demo-form-inline">
        <el-form-item :label="`${$t('langcfg.txtNumberOfShots')}：`">
          <el-select v-model="FBUTtime" @change="changeTime" placeholder="">
            <el-option label="1" value="1"></el-option>
            <el-option label="3" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import EVENTS from "../../../bus";
import { saveCaptureSettings } from "../../../settings";
import { isDefined } from "../../../shared/utils";
export default {
  name: "BUTSetting",
  data() {
    return {
      isDrawBUT: 1,
      showText: this.$t("langcfg.txtOpen"),
      notShowText: this.$t("langcfg.txtShowRuptureArea") + ":  " + this.$t("langcfg.txtClose"),
      auto: this.$t("langcfg.txtAutoSelect"),
      manual: this.$t("langcfg.txtManualSelect"),
      BUTModel: false,
      FBUTtime: 3
    };
  },
  mounted() {
    if (isDefined(window.captureSettings.isDrawBUT)) {
      this.isDrawBUT = window.captureSettings.isDrawBUT === 1;
    } else {
      this.isDrawBUT = true;
      window.captureSettings.isDrawBUT = 1;
      saveCaptureSettings(window.captureSettings);
    }
    if (isDefined(window.captureSettings.BUTModel)) {
      this.BUTModel = window.captureSettings.BUTModel;
    } else {
      this.isDrawBUT = false;
      window.captureSettings.BUTModel = false;
      saveCaptureSettings(window.captureSettings);
    }
    if (isDefined(window.captureSettings.FBUTtime)) {
      this.FBUTtime = window.captureSettings.FBUTtime;
    } else {
      this.FBUTtime = 3;
      window.captureSettings.FBUTtime = 3;
      saveCaptureSettings(window.captureSettings);
    }
  },
  methods: {
    changeSwitch(val) {
      window.captureSettings.isDrawBUT = val ? 1 : 0;
      saveCaptureSettings(window.captureSettings);
    },
    changeModel(val) {
      window.captureSettings.BUTModel = val;
      saveCaptureSettings(window.captureSettings);
      this.$store.state.dryeye.windowBUTModel = val;
    },
    changeTime(val) {
      window.captureSettings.FBUTtime = Number(val);
      saveCaptureSettings(window.captureSettings);
      this.$bus.$emit(EVENTS.fbutVideoTime);
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
.BUT_Setting {
  .demo-form-inline {
    margin-top: 30px;
  }

  margin-top: 30px;
  margin-left: 40px;
  /deep/ .el-form-item__label {
    font-size: 28px !important;
  }
  /deep/ .el-form-item {
    text-align: left;
  }
}
.BUT_name {
  padding-top: 10px;
}
/deep/.el-switch__label * {
  font-size: 27px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/BUTSetting.vue